<template>
    <div class="content_pdf_container">
        <img class="back_icon" src="@/assets/img/contentLibrary/back_icon_2.png" @click="handleBack" />
        <iframe :src="mediaPath" :style="invertedScaleStyles"></iframe>
    </div>
</template>

<script>
export default {
    name: 'ContentPdf',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {

        }
    },
    mounted() {
        console.log("Content PDF Item:", this.item);
    },
    methods: {
        handleBack() {
            this.$emit('close-component');
        }
    },
    computed: {
        mediaPath() {
            return app.api.Utils.getMediaPath(this.item.pdfFile.src);
        },

        invertedScaleStyles() {
            // lets iframe content scale to always be 1! - despite any TK scale
            var currentScale = this.$store.getters.getScaleValue;
            var invertedScale = 1 / currentScale;
            var initScale = 100;
            return {
                'transform': `scale(${invertedScale})`,
                'height': `${currentScale * initScale}%`,
                'width': `${currentScale * initScale}%`
            }

        }
    }

};
</script>

<style lang="scss" scoped>

.content_pdf_container {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: var(--lg-black);
    display: flex;
    justify-content: center;
    align-items: center;

}

iframe {
    position: absolute;
    background-color: #000;
    pointer-events: all;
    border: none;
    border-radius: 5px;
}

.back_icon {
    position: absolute;
    top: -30px;
    left: -1px;
    cursor: pointer;
    z-index: 2;
}
</style>